import { CommonModelDiffRunExecution } from "../entities";
import { Text } from "@merge-api/merge-javascript-shared";
import { ModelDiffBadges } from "../ModelDiffBadges";
import { formatDate } from "../../../../../shared/utils/SharedComponentUtils";
import { ChevronRight } from "lucide-react";
import clsx from "clsx";
interface CompletedDiffCardContentProps {
  diffRun: CommonModelDiffRunExecution;
  isDrawerPrefix?: boolean;
}

const CompletedDiffCardContent = ({
  diffRun,
  isDrawerPrefix = false,
}: CompletedDiffCardContentProps) => {
  const formattedEndTime = diffRun.end_time ? formatDate(diffRun.end_time) : "No end time";

  return (
    <div
      className={clsx("flex flex-row justify-between items-center w-full", {
        "pl-1": isDrawerPrefix,
      })}
    >
      <div className="space-y-1 flex flex-col items-start">
        <div className="flex flex-row space-x-2 items-center">
          <Text as="div" variant={isDrawerPrefix ? "h4" : "md"}>
            {diffRun.linked_account_name}
          </Text>
          {!isDrawerPrefix && <ModelDiffBadges diffResults={diffRun.results} />}
        </div>
        <Text as="div" className="text-gray-40">
          Linked Account ID: {diffRun.linked_account_id}
        </Text>
        <Text as="div" className="text-gray-40">
          Finished {formattedEndTime}
        </Text>
      </div>
      {!isDrawerPrefix && <ChevronRight size={16} />}
    </div>
  );
};

export default CompletedDiffCardContent;
